//axios api
import pharmaGoodApi from "@/lib/PharmaGoodApi";

export const getSetting = async (type) => {
  try {
    const queryRoute = `/admin/settings/${type}`;

    const fetchRes = pharmaGoodApi.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};

export const updateSetting = async (type, value) => {
  try {
    const queryRoute = `/admin/settings/${type}`;

    const fetchRes = pharmaGoodApi.axios.patch(queryRoute, value);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
